import { render, staticRenderFns } from "./TesteAgenda.vue?vue&type=template&id=774bb709"
import script from "./TesteAgenda.vue?vue&type=script&lang=js"
export * from "./TesteAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports